import { has } from 'lodash';
import { call, put, select } from 'redux-saga/effects';
import { singleFetch } from '../middleware/fetch';
import Raven from 'raven-js';
import { auth } from '@peachjar/components';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { get } from 'https';
import config from '../../config';

export const REDIRECT_TO_LOGIN = 'auth/REDIRECT_TO_LOGIN';
export const INITIATE_LOGIN = 'auth/INITIATE_LOGIN';
export const INITIATE_LOGOUT = 'auth/INITIATE_LOGOUT';
export const AUTH_IN_PROGRESS = 'auth/AUTH_IN_PROGRESS';
export const AUTH_SUCCESS = 'auth/AUTH_SUCCESS';
export const AUTH_FAIL = 'auth/AUTH_FAIL';
export const AUTH_LOGGED_OUT = 'auth/AUTH_LOGGED_OUT';
export const AUTH_LOGGED_OUT_FAIL = 'auth/AUTH_LOGGED_OUT_FAIL';
export const RECEIVE_REGISTRATION_ID = 'auth/RECEIVE_REGISTRATION_ID';
export const RECEIVE_REGISTRATION_ID_FAIL = 'auth/RECEIVE_REGISTRATION_ID_FAIL';
export const RECEIVE_REGISTRATION_ID_IN_PROGRESS =
  'auth/RECEIVE_REGISTRATION_ID_IN_PROGRESS';

const PORTAL_API_URL = config.REACT_APP_API_BASE_URL;
const authRedirectUrl = `${
  config.REACT_APP_ACCOUNTS_APP_URL
}/?redirect=${encodeURI(window.location.href)}`;

export const userReducer = (state = {}, action) => {
  switch (action.type) {
    case AUTH_IN_PROGRESS:
      return {
        ...state,
        authCheckComplete: false,
        isAuthenticated: false,
      };
    case AUTH_SUCCESS:
      // Account for Google Auth logins
      if (has(action, 'data.profile')) {
        return {
          ...state,
          authCheckComplete: true,
          isAuthenticated: true,
          id: action.data.id,
          subject: action.data.profile.emails[0].value,
          email: action.data.profile.emails[0].value,
          type: 'internal',
          firstname: action.data.profile.name.givenName,
          lastname: action.data.profile.name.familyName,
          image: action.data.profile.photos[0].value,
        };
      }
      return {
        ...state,
        authCheckComplete: true,
        isAuthenticated: true,
        ...action.data,
      };
    case AUTH_FAIL:
      return {
        ...state,
        authCheckComplete: true,
        isAuthenticated: false,
      };
    case RECEIVE_REGISTRATION_ID:
      return {
        ...state,
        registrationId: action.data.registrationId,
        isRegistrationIdCheckComplete: true,
      };
    case RECEIVE_REGISTRATION_ID_FAIL:
      return {
        ...state,
        isRegistrationIdCheckComplete: true,
      };
    case RECEIVE_REGISTRATION_ID_IN_PROGRESS:
      return {
        ...state,
        isRegistrationIdCheckComplete: false,
      };
    case AUTH_LOGGED_OUT:
      return {
        authCheckComplete: true,
        isAuthenticated: false,
      };
    default:
      return state;
  }
};

export function* verifyAuth() {
  try {
    const response = yield singleFetch({
      url: `${PORTAL_API_URL}/auth/status`,
      method: 'GET',
    });
    yield put({ type: AUTH_SUCCESS, data: response.data.data });
  } catch (error) {
    yield put({ type: AUTH_FAIL });
  }
}

export function* onAuthSuccess() {
  // TODO: get id
  // Raven.setUserContext({
  //   id: '123'
  // })
}

export function* redirectToLogin() {
  const user = yield select(state => state.user);
  const action = yield select(state => state.action);

  try {
    if (!user.authCheckComplete && action === REDIRECT_TO_LOGIN)
      throw new Error('User redirected to login before authCheckComplete');
  } catch (e) {
    Raven.captureException(e);
  }

  // console.info(`Redirect to login AuthCheck ${ ? : 'is complete.' : 'incomplete.'}`)

  window.location.replace(authRedirectUrl);
}

export function* logout() {
  try {
    const response = yield singleFetch({
      url: `${PORTAL_API_URL}/auth/logout`,
      method: 'GET',
    });
    yield call([localStorage, 'removeItem'], 'persist:auth');
    yield put({ type: AUTH_LOGGED_OUT, data: response.data.data });
    yield put({ type: REDIRECT_TO_LOGIN });
  } catch (error) {
    yield put({ type: AUTH_LOGGED_OUT_FAIL });
  }
}

export const receiveRegistrationId = registrationId => {
  return {
    type: RECEIVE_REGISTRATION_ID,
    data: registrationId,
  };
};

const persistConfig = {
  key: 'auth',
  blacklist: ['authCheckComplete'],
  storage,
};

export const persistedUserReducer = persistReducer(persistConfig, userReducer);



// WEBPACK FOOTER //
// ./src/_app/auth/auth.js